// extracted by mini-css-extract-plugin
export var cardIcon = "_4v-4";
export var checkboxCard = "_4v-0";
export var checkboxCardSelected = "_4v-1";
export var disabled = "_4v-2";
export var outerBorder = "_4v-3";
export var spacerMedium = "_4v-7";
export var spacerSmall = "_4v-6";
export var spacerXsmall = "_4v-5";